import { format } from "@hejdoktor/resx-compiler"
export { format }
import { getLocale } from "@hejdoktor/resx-compiler"

import { R as _da } from "./Resources.da.resx"
import { R as _en } from "./Resources.en.resx"
import { R as _no } from "./Resources.no.resx"

type Translations = {
	"Name1": string,
	"Bitmap1": string,
	"Icon1": string,
	"CaregiverChat_ConnectionLost_Message": string,
	"CaregiverChat_MessageList_NewMessagePlaceholder": string,
	"CaregiverChat_MessageList_SendButton": string,
	"CaregiverChat_MessageList_Title": string,
	"CaregiverChat_OnDutyList_NoCaregiversLabel": string,
	"CaregiverChat_OnDutyList_Title": string,
	"CprRequired": string,
	"Close": string,
	"FieldRequired": string,
	"EmailRequired": string,
	"PhoneNumberRequired": string,
	"ErrorOccured": string,
	"ErrorRate": string,
	"InvalidCpr": string,
	"CprTooShort": string,
	"CprTooLong": string,
	"CprTooOld": string,
	"CprTooYoung": string,
	"InvalidName": string,
	"InvalidEmail": string,
	"RequirePaymentText": string,
	"ThankYouForRating": string,
	"EmailAlreadyExist": string,
	"ErrorCompanyData": string,
	"CompanyNameRequired": string,
	"ErrorCompany": string,
	"DeleteCompanyDescription": string,
	"DeleteCompanyTitle": string,
	"ErrorDeletingCompany": string,
	"DeleteCompanyWhiteListDescription": string,
	"DeleteCompanyWhiteListTitle": string,
	"DomainRequired": string,
	"FormInvalidValue": string,
	"ValidDomain": string,
	"ErrorDeletingDoctor": string,
	"ErrorGettingDoctors": string,
	"DoctorEmailAlreadyExist": string,
	"ErrorNewDoctor": string,
	"CouponCodeRequired": string,
	"UsernameRequired": string,
	"FullNameRequired": string,
	"ErrorUpdateProfileData": string,
	"ErrorValidatingInsuranceMembership": string,
	"InvalidPhoneNumber": string,
	"PhoneCallViewModel_ViewIsClosing": string,
	"ErrorGettingPrices": string,
	"ErrorUpdatePrice": string,
	"Child": string,
	"ErrorCompanyConsultations": string,
	"ErrorPatients": string,
	"ValidateCprInvalidCpr": string,
	"Friday": string,
	"Monday": string,
	"Saturday": string,
	"Sunday": string,
	"Thursday": string,
	"Tuesday": string,
	"Wednesday": string,
	"ErrorDeleteAccount": string,
	"ErrorCallQualityFeedback": string,
	"PleaseEnterANumber": string,
	"PleaseEnterFullName": string,
	"CouldNotUpdateChild": string,
	"CouldNotCreateChild": string,
	"ErrorDeleteChild": string,
	"UploadFailedTooLarge": string,
	"Profile_AddChild": string,
	"Profile_EditChild": string,
	"Darn": string,
	"SorryForYourConcerns": string,
	"ThankYou": string,
	"ImproveOurselves": string,
	"Great": string,
	"BigHelp": string,
	"dateFnsShortDateFormat": string,
	"dateFnsTimeFormat": string,
	"dateFnsTodayRelativeFormat": string,
	"dateFnsTomorrowRelativeFormat": string,
	"ProfileConfirmEditKid": string,
	"ClockValidatorError": string,
	"dateFnsLongDateFormat": string,
	"dateFnsLongDateTimeFormat": string,
	"dateFnsShortDateTimeFormat": string,
	"NameRequired": string,
	"TimeZoneWarning": string,
	"Back": string,
	"Next": string,
	"PFAErrorNoAnswer": string,
	"SelectPlaceholder": string,
	"QuestionXOfY": string,
	"ErrorGettingCaregiverTips": string,
	"ErrorNewCaregiverTip": string,
	"Understood": string,
	"PleaseEnterPetName": string,
	"PleaseSelectPetType": string,
	"PleaseSelectPetSex": string,
	"PleaseChoosePetAge": string,
	"PleaseSelectMonth": string,
	"PleaseSelectYear": string,
	"CouldNotGetPets": string,
	"CouldNotCreatePet": string,
	"CouldNotUpdatePet": string,
	"ErrorDeletePet": string,
	"Profile_AddPet": string,
	"Profile_EditPet": string,
	"MonthJanuary": string,
	"MonthFebruary": string,
	"MonthMay": string,
	"MonthMarch": string,
	"MonthApril": string,
	"MonthJune": string,
	"MonthJuly": string,
	"MonthAugust": string,
	"MonthSeptember": string,
	"MonthOctober": string,
	"MonthNovember": string,
	"MonthDecember": string,
	"SelectMonth": string,
	"SelectYear": string,
	"PetSexMale": string,
	"PetSexFemale": string,
	"PetSexMaleNeutered": string,
	"PetSexFemaleSterilized": string,
	"PetSexUnknown": string,
	"PetTypeDog": string,
	"PetTypeCat": string,
	"PetTypeRabbit": string,
	"PetTypeRodent": string,
	"SelectPetType": string,
	"SelectPetSex": string,
	"ErrorFetchingProfileData": string,
	"ErrorDateInTheFuture": string,
	"ErrorTogglingNewsletter": string,
	"MinorChildren": string,
	"ProfileConfirmAddKid": string,
	"FullName": string,
	"CprNumber": string,
	"CprPlaceholder": string,
	"ConfirmCprIsCorrectHeader": string,
	"CprModulusCheckWarning": string,
	"ConfirmAndSave": string,
	"Ok": string,
	"Error": string,
	"UnknownError": string,
	"RefreshDataError": string,
	"FailedFetch": string,
}

const R = new Proxy({}, {
	get(target, name: keyof Translations, receiver) {
		if(process.env.enforcedLocale === "da" || (!process.env.enforcedLocale && getLocale("da") === "da")) {
			return _da[name] ?? name
		}

if(process.env.enforcedLocale === "en" || (!process.env.enforcedLocale && getLocale("da") === "en")) {
			return _en[name] ?? name
		}

if(process.env.enforcedLocale === "no" || (!process.env.enforcedLocale && getLocale("da") === "no")) {
			return _no[name] ?? name
		}

		return name
	},
}) as Translations

export { R }